export default {
  open: false,
  loading: false,
  email: '',
  driver: null,
};
